import { CHANNELS } from "../shared/channels";
import { UserSettings } from "../shared/types";
import { call } from "./bridge";
import { cachedSettings, rememberSettings } from "./settings_cache";

// the places this person pinned as presets. a place id or web:<tab id>, saved per person as pinnedPlaces in their settings

export const MAX_PINS = 6;

let pins: string[] = [];
let saveTimer = 0;
const watchers: Array<() => void> = [];

function tidy(list: unknown): string[] {
  if (!Array.isArray(list)) return [];
  const seen = new Set<string>();
  for (const id of list) if (typeof id === "string" && id && seen.size < MAX_PINS) seen.add(id);
  return [...seen];
}

export function onPinsChanged(watcher: () => void): void {
  watchers.push(watcher);
}

export function getPins(): string[] {
  return pins;
}

export function isPinned(id: string): boolean {
  return pins.includes(id);
}

function changed(): void {
  watchers.forEach((watcher) => watcher());
}

function save(): void {
  window.clearTimeout(saveTimer);
  saveTimer = window.setTimeout(() => {
    void call<UserSettings>(CHANNELS.settingsSave, { pinnedPlaces: pins }).then(rememberSettings).catch(() => undefined);
  }, 350);
}

// false when all the slots are taken, the caller says so
export function togglePin(id: string): boolean {
  if (pins.includes(id)) pins = pins.filter((pin) => pin !== id);
  else if (pins.length >= MAX_PINS) return false;
  else pins = [...pins, id];
  changed();
  save();
  return true;
}

export async function loadPins(): Promise<void> {
  try {
    pins = tidy((await cachedSettings()).pinnedPlaces);
    changed();
  } catch {
    // no presets until settings load
  }
}
